import * as React from 'react';
import { Link } from 'react-router-dom';
import IdentificationDocumentsFormComponent from './IdentificationDocumentsForm.component';
import AddressFormComponent from './AddressForm.component';
import UserProfileFormComponent from './UserProfileForm.component';
import PersonalInformationFormComponent from './PersonalInformationForm.component';
import SpouseDataFormComponent from './SpouseDataForm.component';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import AdditionalDataFormContainer from './AdditionalDataForm.container';
import '../PhysicalPersonUpdate.css';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import Person from 'src/entities/Person';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface PhysicalPersonUpdateComponentProps {
  physicalPerson: PhysicalPerson;
  formData: PhysicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleChangeSpouse: (key: string) => (value: string | File | boolean) => void;
  handleSubmit: () => void;
  profilePicture?: File;
  idFront?: File;
  idBack?: File;
  error: boolean;
  errorMessage: {};
  sectors: SectorOfInterest[];
  defaultProfile?: Person;
  handleChangeDefaultProfile: () => void;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
  handleChangeCheckbox: () => void;
  handlePublicProfileCheckbox: () => void;
}

class EditFormsPhysicalPersonUpdate extends React.PureComponent<PhysicalPersonUpdateComponentProps> {
  public render(): React.ReactNode {
    return (
      <div className="tab-content">
        <div className="gap-10"/>
        <Link to="/mi-cuenta/perfil">
          <span className="close pointer close-form"/>
        </Link>
        <div className="gap-20"/>
        <div className="text-center">
          <h4 className="f-s-16 margin-0-auto text-center">
            {this.props.physicalPerson.displayName}
            <br/>
            <span className="primary-font f-w-100">
              Persona Física
            </span>
            <br/>
          </h4>
          <div className="gap-20"/>
          <p className="margin-0-auto text-center">
            <Link
              to="/mi-cuenta/tipo-de-inversor"
              className="no-credit-link"
            >
              Inversor {this.props.physicalPerson.investorType.type.toLowerCase()}
              {!this.props.physicalPerson.investorType.confirmed ?
                <span className="no-credit"/> :
                null
              }
            </Link>
          </p>
        </div>
        <div className="gap-20"/>
        <hr/>
        <div className="padding-40">
          <p>
            <strong>
              Elige el perfil predeterminado para realizar las inversiones:
            </strong>
          </p>
          <div className="gap-20"/>
          <div className="checkbox">
            <input
              type="checkbox"
              checked={this.props.checkboxState}
              onChange={() => ({})}
            />
            <label
              onClick={(e) => this.props.handleChangeCheckbox()}
            >
              Deseo que este perfil sea mi predeterminado.
            </label>
          </div>
          <div className="gap-20"/>
          <h3 className="inline-block f-s-22 deco-title">
            Datos personales
          </h3>
          <div className="gap-20"/>
          <div className="faqAccordion">
            <PersonalInformationFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            <IdentificationDocumentsFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
              idFront={this.props.idFront}
              idBack={this.props.idBack}
            />
            <AddressFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            <AdditionalDataFormContainer
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            {this.props.formData.maritalStatus === 'Casado/a' &&
            this.props.formData.maritalEconomicStatus === 'Régimen de gananciales' ?
              <SpouseDataFormComponent
                formData={this.props.formData}
                handleChangeSpouse={this.props.handleChangeSpouse}
              /> :
              null
            }
            <UserProfileFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
              profilePicture={this.props.profilePicture}
              sectors={this.props.sectors}
            />
          </div>
          <p>
            <div className="gap-20"/>
            <div className="checkbox">
              <input
                type="checkbox"
                checked={this.props.formData.isPublicProfile}
                onChange={() => ({})}
              />
              <label
                onClick={(e) => this.props.handlePublicProfileCheckbox()}
              >
                Marcar perfil como público, los usuarios registrados podrán ver su perfil.
              </label>
            </div>
          </p>
          {/*TODO*/}
          {/*<Link
            to="/mi-cuenta/perfil-publico"
            className="btn btn-primary-color"
          >
            Ver perfil público
          </Link>*/}
          <div className="text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-container="body"
              data-html="true"
              data-toggle="popover"
              data-placement="bottom"
              onClick={(e) => this.props.handleSubmit()}
            >
              Actualizar
            </button>
            <div className="gap-20"/>
            <ErrorMessagesComponent
              errorMessage={this.props.errorMessage}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EditFormsPhysicalPersonUpdate;


// WEBPACK FOOTER //
// ./src/modules/my-account/physical-person-update/forms/EditFormsPhysicalPersonUpdate.tsx